module.exports = __webpack_public_path__ + "static/img/earn-small.d733a018.webp";